import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {DocumentModel} from '../../models/document.model';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';

@Component({
    selector: 'app-consumables-return',
    templateUrl: './consumables-return.page.html',
    styleUrls: ['./consumables-return.page.scss'],
})
export class ConsumablesReturnPage implements OnInit {
    @Input() document: DocumentModel;
    @Input() consumableLines: DetaillineDTOModel[];


    constructor(public modalController: ModalController) {
    }

    ngOnInit() {
        console.log(this.consumableLines);
    }

    saveConsumables() {
        for (const consumable of this.consumableLines) {
            if (consumable.isChecked) {
                this.document.detailLines.push(consumable);
            }
        }
        this.modalController.dismiss();
    }
}
